var public_nurseslounge_myDashboard_myCredentialVault = {
    init:function($params){
        var $qrWrapper = $("#nurseslounge-home-my-credential-vault-center-qrWrapper");
        $qrWrapper.find(".image-buttons").fadeIn();
        $qrWrapper.find(".save-image-picture").unbind().hide();
        $qrWrapper.find(".my-camera").html('').promise().done(function(){
            $qrWrapper.find(".storage-file").val('').unbind().change(function(){
                var $that = this;
                $qrWrapper.find(".my-camera").html('<img src="data:," class="img-fluid">').promise().done(function(){
                    libs.renderImage($that, $qrWrapper.find(".my-camera img:first")[0]);
                    $qrWrapper.find(".take-image-picture").html('Reset').unbind().click(function(){
                        public_nurseslounge_myDashboard_myCredentialVault.init($params);
                    });
                    $qrWrapper.find(".save-image-picture").click(function(){
                        var $files = $($that)[0].files;
                        if($files != ''){
                            $qrWrapper.find(".my-camera").hide();
                            $qrWrapper.find(".take-image-picture").hide();
                            $qrWrapper.find(".save-image-picture").hide();
                            $qrWrapper.find(".loader-image").show();
                            libs.blobToB64($files[0], function($picture){
                                var $formData = new FormData();
                                $formData.append('_token', $('meta[name="csrf-token"]').attr('content'));
                                $formData.append('user_id', libs.memoryGet('user_id'));
                                $formData.append('hash', $params.hash);
                                $formData.append('picture', $picture);
                                $.ajax({
                                    type: 'POST',
                                    url: '/public/myDashboard/myCredentialsVault/'+$params.hash+'/set',
                                    data: $formData,
                                    cache: false,
                                    contentType: false,
                                    processData: false,
                                    success: function ($data) {
                                        libs.expire($data);
                                    }
                                });
                            });
                        }
                    }).show();
                });
            }).click();
            $qrWrapper.find(".take-image-picture").html('Select New Picture').unbind().click(function(){
                $qrWrapper.find(".storage-file").click();
            }).show();
        });
    }
};
